<template>

<div>
	<v-content style="padding-top: 35px !important; padding-bottom: 35px !important;">
      <v-flex xs3>
        <v-text-field append-icon="search" v-if="regionChildren != null" label="Search" solo single-line v-model="search"></v-text-field><br />
      </v-flex>		
		<v-data-table :search="search" :headers="headers" v-if="regionChildren != null" :items="regionChildren" item-key="name" expand class="elevation-1" :rows-per-page-items="[10,20,40,60,80,100]">
			<template slot="items" slot-scope="props">
				<tr>
					<td class="text-xs-right">{{ props.item.name }}</td>      
					<td class="text-xs-right">{{ props.item.type }}</td>					
					<td v-if="objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1" class="text-xs-right"><a @click.prevent="fncViewChildren(props.item.name, props.item.id, props.item.type)"><i class="material-icons">extension</i></a></td>						
					<td v-if="objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1" class="text-xs-right"><a @click.prevent="fncEditRegion(props.item)"><i class="material-icons">edit</i></a></td>						
					<td v-if="objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1" class="text-xs-right"><a @click.prevent="fncDeleteRegion(props.item)"><i class="material-icons">delete</i></a></td>
				</tr>
			</template>			
		</v-data-table>
      <div class="pl-4 pr-4 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
        </div>
      </div>		
		<p v-if="regionChildren == null" style="padding: 20px;"><strong>No sub regions could be found</strong></p>
	</v-content>	
</div>
</template>

<script>
	
  import { mapGetters } from 'vuex'; 
  import Modal from '@/components/shared/modal';  
  
  export default {
	name: 'PrivList',
    data () {
		return {           
			search: '',
			headers: [         
				{ text: 'Name', value: 'name' },
				{ text: 'Type', value: 'type' },							
				{ text: 'Children', value: 'children' },				
				{ text: 'Edit', value: 'edit' },
				{ text: 'Delete', value: 'delete' }
			]
		}	
	},
    methods: {	
        fncHideModal() {
          this.$store.commit('hideModal');
        },
		fncViewChildren(regionName, regionId, regionType){
			this.$store.dispatch({
				type: 'setObjRegionParents',
				regionType: regionType
			});
			this.$store.dispatch('fncGetRegionChildren', regionId);
			var modalDetails = { title: regionName + ' Locations', component: 'modal-region-children', mstate: true, params: {} };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});			
		},
        fncEditRegion(region) {	          
		    this.$store.dispatch({
				type: 'setObjRegionParents',
				regionType: region.type
			});
			this.$store.commit({
				type: 'setObjRegionEdit',
				regionObj: region
			});
			var modalDetails = { title: 'Edit Region', component: 'modal-region-edit', mstate: true, params: {} };			
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
		fncDeleteRegion(region) {			
			var regionId = region.id;
			var confirmDelete = confirm('Are you sure you want to delete this region');
			if(confirmDelete === true) {
				this.$store.dispatch({
					type: 'fncDeleteRegion',
					id: regionId
				});
			}			
		}
	},
	computed: {
		...mapGetters([			
			'objAuthorize',
			'regionChildren'			
		])
	}
}	
</script>